// extracted by mini-css-extract-plugin
export default {"base":"style_base__jHxkG","horizontal":"style_horizontal__UR2ik","vertical":"style_vertical__bfxJz"};